export class TerminalsMissatge {
    idTerminals: Array<string>;
    missatge: string;

    constructor(idTerminals: Array<string>, missatge: string) {
        this.idTerminals = idTerminals;
        this.missatge = missatge;
    }
}
